import { notificationConstants } from '../constants/notification.constants';

const defaultState = {
	notificationPopup: false,
	popupRequest: null,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case notificationConstants.NOTIFICATION_POPUP: {            
			return {
				...state,
				notificationPopup: true,
				popupRequest: action.payload,
			}
		}
		case notificationConstants.NOTIFICATION_CLEAR: {            
			return {
				...state,
				notificationPopup: false,
				popupRequest: null,
			}
		}
		default:
			return state;
	}
}